import React from 'react';
import { ExpandedTooltip, Icon } from '@livable/saas-react-components';
import { InputAdornment, IconButton } from '@mui/material';
export default function PlainInputTooltip(_ref) {
  let tooltipText = _ref.tooltipText;
  return /*#__PURE__*/React.createElement(InputAdornment, {
    position: "end",
    type: "infoTooltip"
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    type: "grey",
    title: tooltipText,
    placement: "top"
  }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
    state: "info",
    type: "question"
  }))));
}